/**
 * Data Capture API
 *
 * Endpoints:
 *   GET  /jobs/data-capture/:jobId
 *   POST /jobs/data-capture/:jobId/notes
 *   POST /jobs/data-capture/:jobId/images/upload-url
 *   POST /jobs/data-capture/:jobId/images/complete
 *   POST /jobs/data-capture/:jobId/validate
 */

import { apiClient } from '@/lib/api';
import type {
  AddNoteBody,
  CapturedImage,
  DataCaptureImageCompleteBody,
  DataCaptureImageUploadUrlBody,
  DataCaptureImageUploadUrlResponse,
  DataCaptureResponse,
  Note,
  ValidateJobResponse,
} from '@skewb-works/contracts';

export type { DataCaptureResponse };

export async function getDataCapture(jobId: number): Promise<DataCaptureResponse> {
  return apiClient.get<DataCaptureResponse>(`/jobs/data-capture/${jobId}`);
}

export async function addDataCaptureNote(jobId: number, body: AddNoteBody): Promise<Note> {
  return apiClient.post<Note>(`/jobs/data-capture/${jobId}/notes`, body);
}

export async function getDataCaptureImageUploadUrl(
  jobId: number,
  body: DataCaptureImageUploadUrlBody,
): Promise<DataCaptureImageUploadUrlResponse> {
  return apiClient.post<DataCaptureImageUploadUrlResponse>(
    `/jobs/data-capture/${jobId}/images/upload-url`,
    body,
  );
}

export async function completeDataCaptureImageUpload(
  jobId: number,
  body: DataCaptureImageCompleteBody,
): Promise<CapturedImage> {
  return apiClient.post<CapturedImage>(`/jobs/data-capture/${jobId}/images/complete`, body);
}

export async function validateJob(jobId: number): Promise<ValidateJobResponse> {
  return apiClient.post<ValidateJobResponse>(`/jobs/data-capture/${jobId}/validate`, {});
}
